import i18n from '../i18n'

export class TimedOutError extends Error {
  constructor(what: string, ms: number) {
    super(i18n.t('offline.timedOut', { what, seconds: Math.round(ms / 1000) }))
    this.name = 'TimedOutError'
  }
}

export function withTimeout<T>(work: Promise<T>, what: string, ms = 15000): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new TimedOutError(what, ms)), ms)
    work.then(
      value => { clearTimeout(timer); resolve(value) },
      error => { clearTimeout(timer); reject(error) },
    )
  })
}
